(function(){
  if (!/\/products\//.test(location.pathname)) return;
  var productData = null;
  fetch(location.pathname.replace(/\/$/, '') + '.js')
    .then(function(r){ return r.json(); })
    .then(function(p){ productData = p; tick(); })
    .catch(function(){});

  var style = document.createElement('style');
  style.textContent = '' +
    '.price__regular.msrp-label, .price__regular.msrp-label * { text-decoration: none !important; color: inherit; }' +
    '.price__regular.msrp-label::before { content: "MSRP: "; font-weight: 600; }' +
    '.msrp-hide-badge { display: none !important; }';
  document.head.appendChild(style);

  function money(n){ return '$ ' + n.toFixed(2); }
  function currentVariant(){
    if (!productData) return null;
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
    var vid = input ? parseInt(input.value, 10) : NaN;
    var v = null;
    for (var i = 0; i < productData.variants.length; i++) {
      if (productData.variants[i].id === vid) { v = productData.variants[i]; break; }
    }
    return v || productData.variants[0];
  }
  function fixPriceDisplay(){
    var wraps = document.querySelectorAll('.product__price .price__regular');
    for (var i = 0; i < wraps.length; i++) {
      var priceRoot = wraps[i].closest('.price');
      var saleEl = priceRoot ? priceRoot.querySelector('.price__sale') : null;
      if (saleEl && saleEl.textContent.replace(/\s/g, '') !== '') {
        wraps[i].classList.add('msrp-label');
      } else {
        wraps[i].classList.remove('msrp-label');
      }
    }
    var badges = document.querySelectorAll('.badge');
    for (var j = 0; j < badges.length; j++) {
      if (/^sale$/i.test(badges[j].textContent.trim())) {
        var target = badges[j].closest('.badge__container') || badges[j];
        target.classList.add('msrp-hide-badge');
      }
    }
  }
  function tick(){
    fixPriceDisplay();
    var v = currentVariant();
    if (!v) return;
    var msrp = v.compare_at_price ? v.compare_at_price / 100 : null;
    var table = document.querySelector('.wpd_vd_main_container table');
    if (!table || !table.rows.length) return;
    var marker = 'v' + v.id;
    if (table.getAttribute('data-msrp-variant') === marker) return;
    var old = table.querySelectorAll('.msrp-added');
    for (var j = old.length - 1; j >= 0; j--) { old[j].parentNode.removeChild(old[j]); }
    if (!msrp) { table.setAttribute('data-msrp-variant', marker); return; }
    var head = table.rows[0];
    var th1 = document.createElement('th'); th1.textContent = 'MSRP'; th1.className = 'msrp-added';
    var th2 = document.createElement('th'); th2.textContent = 'Your Margin'; th2.className = 'msrp-added';
    head.appendChild(th1); head.appendChild(th2);
    for (var i = 1; i < table.rows.length; i++) {
      var row = table.rows[i];
      if (!row.cells.length) continue;
      var priceTxt = row.cells[row.cells.length - 1].textContent.replace(/[^0-9.]/g, '');
      var price = parseFloat(priceTxt);
      var td1 = document.createElement('td'); td1.className = 'msrp-added'; td1.textContent = money(msrp);
      var td2 = document.createElement('td'); td2.className = 'msrp-added';
      td2.textContent = (price && msrp > 0) ? Math.round((msrp - price) / msrp * 100) + '%' : '—';
      row.appendChild(td1); row.appendChild(td2);
    }
    table.setAttribute('data-msrp-variant', marker);
  }
  setInterval(tick, 600);
})();
